document.addEventListener("DOMContentLoaded", async function () {

    const banner = document.getElementById("pm-gift-card-banner");

    if (!banner) return;

    const sku = banner.dataset.sku;

    try {

        const response = await fetch(window.pmGiftCardDataUrl);
        const data = await response.json();

        console.log("SKU:", sku);
        console.log("JSON:", data);

        const gift = data[sku];

        console.log("Gift:", gift);

        if (!gift) {

            console.log("Este producto no participa.");

            return;

        }

        const amount = banner.querySelector(".pm-gift-card-banner__amount");

        if (amount) {
            amount.textContent = "$" + gift.toLocaleString("es-CL");
        }

        banner.style.display = "block";

    }

    catch (error) {

        console.error(error);

    }

});